import { alpha, IconButton, Stack, styled, Button as MuiButton } from '@mui/material';

import palette from '../theme/palette';

export const BUTTON_WIDTH = '146px';

export const Button = styled(MuiButton)({
  height: 40,
  width: BUTTON_WIDTH,
  borderRadius: 20,
  padding: 12,
  border: 'unset',
  textTransform: 'none',
  fontSize: 12,
  backgroundColor: palette.black,
  color: palette.white,
  '&:disabled': {
    color: palette.white,
    backgroundColor: palette.grey[2500]
  },
  '&:hover': {
    backgroundColor: palette.grey[2600]
  }
});

export const SaveButton = styled(Stack)(({ disabled }: { disabled?: boolean }) => ({
  height: '40px',
  width: BUTTON_WIDTH,
  borderRadius: '20px',
  justifyContent: 'center',
  backgroundColor: disabled ? palette.grey[700] : palette.black,
  padding: '12px',
  alignItems: 'center',
  pointerEvents: disabled ? 'none' : 'auto',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.4 : 1,
  color: palette.white,
  fontSize: '13px',
  fontWeight: 600,
  ':hover': { opacity: 0.8 }
}));

export const CancelButton = styled(Stack)(({ disabled }: { disabled?: boolean }) => ({
  height: '40px',
  width: BUTTON_WIDTH,
  borderRadius: '20px',
  backgroundColor: palette.grey[800],
  padding: '12px',
  alignItems: 'center',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.4 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  fontSize: '13px',
  fontWeight: 600,
  ':hover': { opacity: 0.8 }
}));

export const DeleteButton = styled(Stack)(() => ({
  height: '40px',
  width: BUTTON_WIDTH,
  borderRadius: '20px',
  backgroundColor: palette.red[100],
  padding: '12px',
  alignItems: 'center',
  cursor: 'pointer',
  color: palette.white,
  fontSize: '13px',
  fontWeight: 600,
  ':hover': { opacity: 0.8 }
}));

export const CloseModalButton = styled(IconButton)({
  display: 'flex',
  width: '44px',
  height: '44px',
  borderRadius: '50%',
  padding: '8px',
  background: alpha(palette.black, 0.4),
  backdropFilter: 'blur(10px)',
  justIyContent: 'center',
  alignItems: 'center'
});
